<script setup lang="ts" generic="T extends SelectableValue">
import FormComboboxInput, {
  FormComboboxProps
} from '@/components/formComboboxInput/FormComboboxInput.vue';
import { Selectable, SelectableValue } from '@/components/selectBox/selectBox';
import { useProgramsSearch } from '@/hooks/search/useProgramsSearch';

const props = defineProps<Omit<FormComboboxProps<number>, 'options'>>();

defineEmits<{
  'update:modelValue': [Selectable<number> | null];
}>();

const { programOptions, isLoading, onQueryChange } = useProgramsSearch(props.searchFilters);
</script>

<template>
  <FormComboboxInput
    v-bind="$props"
    :isLoading="isLoading"
    :options="programOptions"
    :onFilter="onQueryChange"
    :modelValue="modelValue as Selectable<number>"
    @update:modelValue="(value) => $emit('update:modelValue', value as Selectable<number>)"
    @open="() => onQueryChange('')"
  />
</template>
